<script>import { createEventDispatcher, getContext, onMount } from "svelte";
export let options = [{ value: false }, { value: true }];
export let story = void 0;
export let contextKey;
const ctx = getContext(contextKey);
let { name, empty, dirty, focus, visited, disabled, value } = ctx;
let startValue = $value === options[1].value ? $value : options[0].value;
const setInitialValue = $value === void 0 || startValue !== $value;
let checked = startValue === options[1].value;
let initialValue = $value;
let state = {
  empty: $empty,
  dirty: $dirty,
  focus: $focus,
  visited: $visited,
  disabled: $disabled
};
const dispatch = createEventDispatcher();
const storyClasses = (story ?? "check").split(".");
if (storyClasses[storyClasses.length - 1] === "disabled") {
  storyClasses.splice(storyClasses.length - 1, 1);
  $disabled = true;
}
let labelsPresent = !!options[0].label || !!options[1].label;
const getLabel = (value2) => options.filter((option) => option.value === value2).map((option) => option.label).join(", ");
let label = getLabel($value);
$: {
  $empty = $value === void 0;
  $dirty = !$disabled ? ($value !== void 0 || !initialValue != void 0) && $value !== initialValue : false;
  $focus = !$disabled ? $focus : false;
  $visited = !$disabled ? $visited : false;
  let changes = {};
  if ($empty != state.empty) {
    changes.empty = $empty;
  }
  if ($dirty != state.dirty) {
    changes.dirty = $dirty;
  }
  if ($focus != state.focus) {
    changes.focus = $focus;
  }
  if ($visited != state.visited) {
    changes.visited = $visited;
  }
  state = { empty: $empty, dirty: $dirty, focus: $focus, visited: $visited, disabled: $disabled };
  if (Object.keys(changes).length > 0) {
    dispatch("state", { changes, state });
  }
}
onMount(() => {
  if (setInitialValue && !$disabled) {
    $value = startValue;
    dispatch("changed", {
      name,
      value: $value
    });
  }
});
const handleInteraction = (isChecked) => {
  const newValue = options[checked ? 1 : 0].value;
  if (newValue != $value && !$disabled) {
    $value = newValue;
    label = getLabel($value);
    dispatch("changed", {
      name,
      value: $value
    });
  }
};
const handleExternalValue = (externalValue) => {
  startValue = externalValue === options[1].value ? externalValue : options[0].value;
  checked = startValue === options[1].value;
  initialValue = externalValue;
  label = getLabel(externalValue);
};
$: {
  handleInteraction(checked);
}
$: {
  handleExternalValue($value);
}
</script>

<div class="checkBox">
	<input
		disabled={$disabled}
		type="checkbox"
		class="checkBox {storyClasses.join(' ')}"
		bind:checked
		on:focus={() => {
			$visited = true;
			$focus = true;
		}}
		on:blur={() => {
			$focus = false;
		}}
	/>{#if labelsPresent}<span class="valueLabel">{label}</span>{/if}<input
		{name}
		disabled={$disabled}
		value={$value}
		type="hidden"
		class="hidden"
	/>
</div>

<style>
  .checkBox {
    --input-font: 700 1.125rem/1.2 "Roboto";
    --input-font-size: 1.125rem;
    --input-line-height: 1.2;
    --input-letter-spacing: 0.0625rem;
    --ratio: 1;
    --border-size: 0.125rem;
    --item-spacing: 0.5rem;
    --fill0: #121316;
    --fill1: #46464A;
    --disabled-fill: #46464A;
    --border-color0: #121316;
    --border-color1: #46464A;
    --disabled-border-color: #46464A;
    --handle-color0: transparent;
    --handle-color1: #6BAE85;
    --disabled-handle-color: #46464A;
    --on-surface-color0: #121316;
    --on-surface-color1: #46464A;
    --disabled-on-surface-color: #46464A;
    --text-color: #DBE4E7;
    --inactive-content: '';
    --active-content: '';
  }

  .check {
    
  }

  .small {
    --input-font: 700 0.6875rem/1.2 "Roboto";
    --input-font-size: 0.6875rem;
    --input-line-height: 1.2;
    --input-letter-spacing: 0.0625rem;
  }

  .switch {
    --handle-color0: #FFFFFF;
    --handle-color1: #FFFFFF;
    --ratio: 2;
  }

  .iconToggle {
    --fill0: transparent;
    --fill1: transparent;
    --border-color0: transparent;
    --border-color1: transparent;
    --handle-color0: transparent;
    --handle-color1: transparent;
    --on-surface-color0: #FFFFFF;
    --on-surface-color1: #FFFFFF;
    --border-size: 0rem;
    --disabled-fill: transparent;
    --disabled-handle-color: transparent;
  }

  .eyes {
    --inactive-content: '\f070';
    --active-content: '\f06e';
  }

  .lightdark {
    --inactive-content: '\e91f';
    --active-content: '\e91c';
  }

  .yesno {
    --inactive-content: '\e911';
    --active-content: '\e912';
  }

	.checkBox {
		--height: calc(var(--input-font-size) + 2 * var(--border-size));
		--width: calc(var(--height) * var(--ratio));
	}

	div.checkBox {
		height: calc(var(--input-font-size) + 2 * var(--border-size));
		line-height: 1;
		display: inline-flex;
		align-items: center;
		gap: var(--item-spacing);
	}

	.checkBox input.checkBox {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		-webkit-tap-highlight-color: transparent;
		cursor: pointer;
		font-size: var(--input-font-size);
	}
	.checkBox input.checkBox:focus {
		outline: 0;
	}

	div.control fieldset div.content span.input .checkBox input.checkBox,
	.checkBox input.checkBox {
		height: var(--height);
		width: var(--width);
		border-radius: calc(var(--height) / 2);
		display: inline-block;
		position: relative;
		border-width: var(--border-size);
		border-style: solid;
		box-sizing: border-box;
	}

	.checkBox input.checkBox:checked:before {
		transform: translate(calc(var(--width) - var(--height)));
	}

	.checkBox input.checkBox:before {
		line-height: 0.9;
		width: 1em;
		height: 1em;
	}

	.checkBox input.checkBox:before {
		position: absolute;
		border-radius: 50%;
		transition: all 0.02s cubic-bezier(0.5, 0.1, 0.75, 1.35);
		text-align: center;
		text-decoration: inherit;

		/* use !important to prevent issues with browser extensions that change fonts */
		font-family: 'tlmd-glyphs' !important;
		font-style: normal;
		font-weight: normal;
		font-variant: normal;
		text-transform: none;

		/* Enable Ligatures ================ */
		letter-spacing: 0;
		-webkit-font-feature-settings: 'liga';
		-moz-font-feature-settings: 'liga=1';
		-moz-font-feature-settings: 'liga';
		-ms-font-feature-settings: 'liga' 1;
		font-feature-settings: 'liga';
		-webkit-font-variant-ligatures: discretionary-ligatures;
		font-variant-ligatures: discretionary-ligatures;

		/* Better Font Rendering =========== */
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	div.control fieldset div.content span.input div.checkBox input.checkBox,
	.checkBox input.checkBox {
		background: var(--fill0);
		border-color: var(--border-color0);
	}
	div.control fieldset div.content span.input div.checkBox input.checkBox:checked,
	.checkBox input.checkBox:checked {
		background: var(--fill1);
		border-color: var(--border-color1);
	}
	div.control fieldset div.content span.input div.checkBox input.checkBox:disabled,
	.checkBox input.checkBox:disabled {
		background: var(--disabled-fill);
		border-color: var(--disabled-border-color);
		cursor: default;
	}

	.checkBox input.checkBox:before {
		color: var(--on-surface-color0);
		background-color: var(--handle-color0);
	}
	.checkBox input.checkBox:checked:before {
		color: var(--on-surface-color1);
		background-color: var(--handle-color1);
	}

	.checkBox input.checkBox:disabled:before {
		color: var(--disabled-on-surface-color);
		background-color: var(--disabled-handle-color);
	}

	.checkBox span.valueLabel {
		color: var(--text-color);
		font: var(--input-font);
	}

	.checkBox input.checkBox:before {
		content: var(--inactive-content);
	}
	.checkBox input.checkBox:checked:before {
		content: var(--active-content);
	}

	.checkBox input.hidden {
		position: absolute;
	}
</style>
